export enum SpecialInfoTypes {
  HOTELS_OFF_TRAVEL = 'HOTELS_OFF_TRAVEL',
  BLACK_WEEKEND = 'BLACK_WEEKEND',
  CASHBACK = 'CASHBACK',
  ELO = 'ELO',
  LIVELO = 'LIVELO',
  TUDO_AZUL = 'TUDO_AZUL',
  PONTOS_DOTZ = 'PONTOS_DOTZ',
  CASHBACK30MX = 'CASHBACK30MX',
  RAPPICARD_TERMS = 'RAPPICARD_TERMS',
  INSTALLMENTS = 'INSTALLMENTS',
  GYRA_TRAVESIA = 'GYRA_TRAVESIA',
  PREVIAJE_II = 'PREVIAJE_II',
  CASHBACK_HOTELS_AND_CARS = 'CASHBACK_HOTELS_AND_CARS',
  BLACK_FRIDAY = 'BLACK_FRIDAY',
  CHUBB = 'CHUBB',
  DAVIVIENDA = 'DAVIVIENDA',
  RAPPI_TRAVEL = 'RAPPI_TRAVEL',
  HOTELS_5_PER = 'HOTELS_5_PER',
  DUTY_FREE = 'DUTY_FREE',
  CIVITATIS = 'CIVITATIS',
}
